/* eslint class-methods-use-this: 0 */
import { IGridHelper } from '@components-clean/core/api-grid/helpers/interfaces';
import { CustomCells } from '@components-clean/core/grid/custom-cell';
import { ChipProps, RAGPillColours } from '@components-clean/core/grid/custom-cell/chip-constants';
import { ColumnDefinition } from '@interfaces/central-monitoring';

enum ObservationColumns {
    Association = 'association',
    Panel = 'panel',
    CreatedBy = 'created_by',
    CreatedDate = 'created_date',
    Id = 'id',
    UpdatedBy = 'updated_by',
    ClosedDatePopulatedOn = 'closed_date_populated_on',
    Owner = 'owner_name',
    RootCause = 'root_cause',
    Observation = 'observation',
    Comments = 'comments',
    RecordId = 'record_id',
    Decision = 'decision',
    LatestPanelScore = 'latest_panel_score',
    Status = 'status',
    ObservationDate = 'observation_date',
    DateSetOpenedOn = 'dateset_opened_on',
    Reviews = 'reviews',
    OpenActions = 'open_actions',
    RecentAction = 'recent_action',
    UpdatedDate = 'updated_date',
    ClosedDate = 'closed_date',
    Type = 'type',
    SiteName = 'site_name',
    TimePeriodLatestStatus = 'time_period_latest_status',
}

const ragChips: ChipProps[] = [
    {
        text: 'Upper Red',
        value: 'Upper Red',
        backgroundColor: RAGPillColours.ragRed,
        borderColor: RAGPillColours.ragRedBorder,
    },
    {
        text: 'Upper Amber',
        value: 'Upper Amber',
        backgroundColor: RAGPillColours.ragAmber,
        borderColor: RAGPillColours.ragAmberBorder,
    },
    {
        text: 'Lower Amber',
        value: 'Lower Amber',
        backgroundColor: RAGPillColours.ragAmber,
        borderColor: RAGPillColours.ragAmberBorder,
    },
    {
        text: 'Lower Red',
        value: 'Lower Red',
        backgroundColor: RAGPillColours.ragRed,
        borderColor: RAGPillColours.ragRedBorder,
    },
    {
        text: 'Below Min Data',
        value: 'Below Min Data',
        backgroundColor: RAGPillColours.ragGrey,
        borderColor: RAGPillColours.ragGreyBorder,
    },
    {
        text: 'Green',
        value: 'Green',
        backgroundColor: RAGPillColours.ragGreen,
        borderColor: RAGPillColours.ragGreenBorder,
    },
];

export class ObservationGridHelper implements IGridHelper {
    private _customCells: CustomCells;

    constructor(private customCells: CustomCells) {
        this._customCells = customCells;
    }

    getDisplayFields(columnType: ColumnDefinition) {
        switch (columnType.dataField) {
            case ObservationColumns.CreatedBy:
            case ObservationColumns.CreatedDate:
            case ObservationColumns.Id:
            case ObservationColumns.UpdatedBy:
            case ObservationColumns.ClosedDatePopulatedOn:
            case ObservationColumns.RecordId:
                return false;
            default:
                return true;
        }
    }

    getActiveField(columnType: ColumnDefinition) {
        switch (columnType.dataField) {
            case ObservationColumns.Association:
            case ObservationColumns.Panel:
            case ObservationColumns.Owner:
            case ObservationColumns.Decision: {
                return `${columnType.dataField}_active`;
            }
            default:
                return undefined;
        }
    }

    getDisplayTooltipFields(columnType: ColumnDefinition) {
        switch (columnType.dataField) {
            case ObservationColumns.RootCause:
            case ObservationColumns.Owner:
            case ObservationColumns.Observation:
            case ObservationColumns.Comments:
            case ObservationColumns.Panel:
            case ObservationColumns.Association:
            case ObservationColumns.Decision:
                return true;
            default:
                return false;
        }
    }

    isRagColumn(columnType: ColumnDefinition) {
        switch (columnType.dataField) {
            case ObservationColumns.LatestPanelScore:
                return true;
            default:
                return false;
        }
    }

    disableLock() {
        return false;
    }

    multiValueFilter() {
        return false;
    }

    observationColumnsWidth: Map<string | null | undefined, number> = new Map([
        [ObservationColumns.Type, 115],
        [ObservationColumns.Status, 110],
        [ObservationColumns.SiteName, 115],
        [ObservationColumns.Association, 180],
        [ObservationColumns.Panel, 180],
        [ObservationColumns.ObservationDate, 145],
        [ObservationColumns.Observation, 400],
        [ObservationColumns.Owner, 200],
        [ObservationColumns.Decision, 190],
        [ObservationColumns.DateSetOpenedOn, 145],
        [ObservationColumns.Reviews, 75],
        [ObservationColumns.OpenActions, 110],
        [ObservationColumns.RecentAction, 120],
        [ObservationColumns.RootCause, 200],
        [ObservationColumns.Comments, 200],
        [ObservationColumns.UpdatedDate, 145],
        [ObservationColumns.ClosedDate, 145],
        [ObservationColumns.ClosedDatePopulatedOn, 145],
        [ObservationColumns.ClosedDate, 145],
        [ObservationColumns.RecordId, 100],
        [ObservationColumns.CreatedBy, 145],
        [ObservationColumns.UpdatedBy, 145],
    ]);

    getColumnWidth(columnType: ColumnDefinition): number | undefined {
        return this.observationColumnsWidth.get(columnType.dataField);
    }

    getCustomCell(columnType: ColumnDefinition) {
        switch (columnType.dataField) {
            case ObservationColumns.TimePeriodLatestStatus:
                return this._customCells.ChipCell(ragChips, { width: 120 });
            default:
                return undefined;
        }
    }

    disableAdvancedFilter() {
        return false;
    }
}
